export default {"src":"/_next/static/media/crown-upgrade.6fa4021c.svg","height":179,"width":188,"blurWidth":0,"blurHeight":0};